var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0 px-4",attrs:{"prepend-icon":_vm.prepend,"hide-details":"","input-value":!_vm.$vuetify.theme.isDark},on:{"change":_vm.toggleTheme}})}
var staticRenderFns = []

export { render, staticRenderFns }